require('./Content.less');



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/Content/Content.js
// module id = 74
// module chunks = 0